var site = site || {};

(function ($) {
  site.ShadePicker = function (productData) {
      //console.log('init productData: ' + productData.PRODUCT_ID);
      this.init(productData);
  };

  site.ShadePicker.prototype = {
    productData : null,
    skus: [],
    skuShades : [],
    swatches : '',
    shadeSelects : '',
    originalUrl : window.location.href.split('#/shade/')[0],
    initialShadeRoute : window.location.href.split('#/shade/')[1],
    wireSwatches : function(){
      var self = this;
      self.swatches.on( "click", function(e) {
        e.preventDefault();
        var selectedSkuBaseId = $(this).attr("data-sku-base-id");
        self.updateSwatches(selectedSkuBaseId);
        site.skuSelect(self.skus[selectedSkuBaseId]);
        self.selectShade(selectedSkuBaseId);
      });
      self.swatches.on( "sku:select", function(e, skuData) {
        if ($(this).data('skuBaseId') !== skuData.SKU_BASE_ID) {
          // event loops over all swatches from the product
          // only update on the selected swatch
          return;
        }
        var selectedSkuBaseId = skuData.SKU_BASE_ID;
        self.updateSwatches(selectedSkuBaseId);
        e.stopPropagation();
      });
      //init first swatch
      self.swatches.eq(0).addClass("selected");
    },
    wireShadeSelects : function() {
      var self = this;
      self.customSelects(true);
      self.shadeSelects.on('change', function(e) {
        var selectedSkuBaseId = $(this).val();
        self.updateSelects(selectedSkuBaseId);
        site.skuSelect(self.skus[selectedSkuBaseId]);
        self.selectShade(selectedSkuBaseId);
      });
      self.shadeSelects.on( "sku:select", function(e, skuData) {
        var selectedSkuBaseId = skuData.SKU_BASE_ID;
        self.updateSelects(selectedSkuBaseId);
        e.stopPropagation();
      });
    },
    customSelects : function(init) {
      var self = this;
      self.shadeSelects.each(function(index, val) {
        if(init){
          $(this).selectBox({ mobile: true });
        }else{
          $(this).selectBox('refresh');
          //self.shadeSelects.selectBox('destroy');
          //self.shadeSelects.selectBox({ mobile: true });
        }
        var $shadeSelect = $(this).selectBox('control');
        var $shadeSelectOption = $($shadeSelect).data('selectBox-options');  // extra $() for iPad
        if(init){
          $(this).selectBoxDefault('selectDefault');
          $('.product-full__quantity').selectBoxDefault('selectDefault');
          $('.spp-product__mini-bag-quantity').selectBoxDefault('selectDefault');
        }

        if($shadeSelectOption != null){
          var $shadeMenuOptions = $shadeSelectOption.find('li a');
          // add shade divs to custom select
          $shadeMenuOptions.each(function() {
            var shadeSku = $(this).attr('rel');
            //var shadeProductData = _.find(self.skus, function(p){ return p.SKU_BASE_ID == shadeSku; });
            var shadeProductData = _.find(self.productData.skus, function(sku){ return sku.SKU_BASE_ID == shadeSku; });
            var shadeHex = shadeProductData.HEX_VALUE_STRING;

            // explode
            var shadeHex = shadeHex.split(',');

            //sort swathes
            var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;
            if(shadeHex.length == 1) {
              swatchType = 'swatches--single';
              hexValue1 = shadeHex[0];
            }else if(shadeHex.length == 2){
              swatchType = 'swatches--duo';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
            }else if(shadeHex.length == 3){
              swatchType = 'swatches--trio';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
            }else if(shadeHex.length == 4){
              swatchType = 'swatches--quad';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
              hexValue4 = shadeHex[3];
            }else if(shadeHex.length == 5){
              swatchType = 'swatches--quint';
              hexValue1 = shadeHex[0];
              hexValue2 = shadeHex[1];
              hexValue3 = shadeHex[2];
              hexValue4 = shadeHex[3];
              hexValue5 = shadeHex[4];
            }

            var $swatchContainer = $('<div/>', {
              'class': 'swatch__container ' + swatchType
            });
            for(var i=0; i<shadeHex.length; i++){
              var $swatchDiv = $('<div/>', {
                'class': 'swatch--'+(i+1),
                'style': 'background-color:'+shadeHex[i]
              });
              $swatchContainer.append($swatchDiv);
            }

            // add to li
            $(this).prepend($swatchContainer).clone(true);
            // add to label
            if($(this).parent().hasClass('selectBox-selected') || $(this).attr('rel') === self.selectedSkuId) {
              var $shadeSelectLabel = $shadeSelect.parent().find('.selectBox-dropdown');
              if($('.swatch__container',$shadeSelectLabel).length){
                var $clone = $swatchContainer.clone(true);
                $('.swatch__container',$shadeSelectLabel).replaceWith($clone);
              }else{
                var $clone = $swatchContainer.clone(true);
                $shadeSelectLabel.prepend($clone);
              }
            }
          });
        }
      });
    },
    updateSwatches : function(skuId){
      var self = this;
      self.swatches.removeClass("selected");
      self.swatches.filter("[data-sku-base-id=" + skuId +  "]").addClass("selected");
    },
    updateSelects : function(skuId){
      var self = this;
      self.shadeSelects.val(skuId);
      self.selectedSkuId = skuId + '';
      self.customSelects(false);
    },
    fixedEncodeURIComponent : function (str){ //CX-3730 Deep Link Implementation
      try {
        return str.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
      }
      catch(err) {
        // console.log('shadename is undefined');
      }
    },
    hasQueryString : function () { //CX-3730 Deep Link Implementation
      var self = this;
      if (_.isEmpty(self.initialShadeRoute.split('?')[1])) {
        return false;
      } else {
        return true;
      }
    },
    shadeInit : function () { //CX-3730 Deep Link Implementation
      var self = this;
      var shadeRoutefromURL = self.initialShadeRoute;
      if (shadeRoutefromURL !== undefined) {
        self.shadeRouteInit(shadeRoutefromURL);
        return;
      }

      // SD shade routing
      shadeRoutefromURL = self.getUrlParam('shade');
      if (!!shadeRoutefromURL) {
        self.shadeRouteParamsInit(shadeRoutefromURL);
        return;
      }

      self.defaultshadeSelect();
    },

    shadeRouteInit: function(shadeRoutefromURL) {
      var self= this;
      var shadeNameNoSpaces = '';
      var foundShadeSkuId = '';

      if (self.hasQueryString()) {
        shadeRoutefromURL = self.initialShadeRoute.split('?')[0];
      }
      shadeNameNoSpaces = self.fixedEncodeURIComponent(decodeURIComponent(shadeRoutefromURL));
      if (_.contains(self.skuShades, shadeNameNoSpaces)) {
        foundShadeSkuId = self.skuShades.indexOf(shadeNameNoSpaces);
        $("a.swatch[data-sku-base-id=" + foundShadeSkuId + "]").trigger('click');
      } else {
        self.defaultshadeSelect();
      }
    },

    shadeRouteParamsInit: function(shadeRoutefromURL) {
      var self = this;
      var shadeNameNoSpaces = self.fixedEncodeURIComponent(decodeURIComponent(shadeRoutefromURL));
      var foundShadeSkuId = '';
      if (_.contains(self.skuShades, shadeNameNoSpaces)) {
        foundShadeSkuId = self.skuShades.indexOf(shadeNameNoSpaces);
        window.history.replaceState({}, document.title, window.location.pathname);
        $("a.swatch[data-sku-base-id=" + foundShadeSkuId + "]").trigger('click');
      } else {
        self.defaultshadeSelect();
      }
    },

    getUrlParam: function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      var value = null
      if (!!results) {
         value = decodeURI(results[1]) || 0;
      }
      return value;
    },
    selectShade : function (selectedSkuBaseId) { //CX-3730 Deep Link Implementation
      var self = this;
      if (!_.isEmpty(self.skuShades) && Drupal.settings.globals_variables.enable_deep_link) {
        var selectedShade = self.skuShades[selectedSkuBaseId];
        if ( (page_data['custom-spp'] || page_data['catalog-spp']) && $(document).find('.quickshop').length < 1) {
          if (self.initialShadeRoute !== undefined && self.hasQueryString()) {
            selectedShade = selectedShade + '?' + self.initialShadeRoute.split('?')[1];
          }
          history.replaceState({}, selectedShade, '#/shade/' + selectedShade);
        }
      }
    },
    defaultshadeSelect : function () {
      var defaultSku = $('a.swatch--selected.selected').data('sku-base-id');
      $("a.swatch[data-sku-base-id=" + defaultSku + "]").trigger('click');
    },
    init: function (productData) {
      var self = this;
      self.productData = productData;
      var pid = self.productData.PRODUCT_ID;
      for (var i=0; i<self.productData.skus.length; i++) {
        var s = self.productData.skus[i];
        self.skus[s.SKU_BASE_ID] = s;
        //CX-3730 Deep Link Implementation
        if (s.SHADENAME != null && Drupal.settings.globals_variables.enable_deep_link) {
          var shadeNameNoSpaces = self.fixedEncodeURIComponent(s.SHADENAME);
          self.skuShades[s.SKU_BASE_ID] = shadeNameNoSpaces;
        }
        //self.skus.push(s);
      }

      //check for swatches
      self.swatches = $("a.swatch[data-product-id=" + pid + "]");
      if(self.swatches.length > 0){
        self.wireSwatches(self.swatches);
      }
      //check for selects
      self.shadeSelects = $("select.js-sku-menu[data-product-id=" + pid + "]");
      if(self.shadeSelects.length > 0){
        self.wireShadeSelects(self.shadeSelects);
      }
    }
  };


  site.SmooshSlider = function(args) {
    var that = {
      $list : $(args.containerNode)
    };
    var productData = args.productData;
    //smoosh list
    setTimeout(function(){
      that.$list.slick({
        lazyLoad: 'progressive',
        centerPadding: '50%',
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        rtl: site.direction.isRTL
      });

      that.$list.on('afterChange', function (e, slick) {
        const currentSlide = slick.currentSlide;
        const skuBaseId = $(slick.$slides).eq(currentSlide).find('.js-smoosh-list-item').attr('data-sku-base-id');

        $('a.swatch[data-sku-base-id=' + skuBaseId + ']', '.js-shade-picker').trigger('click');
      });

      $(document).trigger('smoosh_slick_init_ready');
    },200); //give the first image some time to load
    that.$list.on('init', function(event, slick) {
      $(slick.$slides).addClass('js-slick-slide');
    });

    //hook into shade picker
    that.$list.on('sku:select', function(e, skuData) {
      e.stopPropagation();
      var skuId = skuData.SKU_BASE_ID;
      var $smooshes= $('.smoosh-list-item', that.$list);
      var smooshIndex = $smooshes.filter("[data-sku-base-id=" + skuId + "]").closest('.js-slick-slide').attr('data-slick-index');
      if (!that.$list.hasClass('slick-initialized')) {
        return;
      }
      var currentSlide = that.$list.slick('slickCurrentSlide');
      if(smooshIndex != currentSlide) {
        that.$list.slick('slickGoTo', smooshIndex);
      }
    });

    return that;

  };
})(jQuery);


